export const SOCKET_EVENTS = {
  CONNECTED: 'connected',
  NOTIFICATION: 'notification',
  ORDER_STATUS_UPDATE: 'order:status_update',
  DELIVERY_AGENT_LOCATION: 'deliveryAgentLocation',
  SUPPORT_ROOM_READY: 'support:room_ready',
  SUPPORT_MESSAGE: 'support:message',
  SUPPORT_READ: 'support:read',
  GROUP_JOINED: 'group:joined',
  GROUP_MEMBER_JOINED: 'group:member_joined',
  GROUP_MEMBER_LEFT: 'group:member_left',
  GROUP_HOST_CHANGED: 'group:host_changed',
  GROUP_ITEM_ADDED: 'group:item_added',
  GROUP_ITEM_UPDATED: 'group:item_updated',
  GROUP_ITEM_REMOVED: 'group:item_removed',
  GROUP_CHECKOUT_STARTED: 'group:checkout_started',
  GROUP_CHECKOUT_FAILED: 'group:checkout_failed',
  GROUP_SESSION_CONFIRMED: 'group:session_confirmed',
  GROUP_SESSION_EXPIRED: 'group:session_expired',
} as const;

export type SocketEventName =
  (typeof SOCKET_EVENTS)[keyof typeof SOCKET_EVENTS];
